import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { includes, isNil, toUpper } from 'lodash'
import { Menu, MenuButton, MenuItem, MenuDropdown, MenuLink } from './Shared'

const HostSubMenu = ({ host }) => {
  const hostName = toUpper(host.name.split('.')[0])

  return (
    <Menu>
      <MenuButton text={hostName} textToCopy={host.name} />

      <MenuDropdown style={{ textAlign: 'right', minWidth: '330px' }}>
        <MenuItem>
          Service console: {isNil(host.service_console_ip) ? 'Not found' : (
            <Fragment>
              <MenuLink text={host.service_console_ip} href={`https://${host.service_console_ip}/ui`} />
              {' | '}
              <MenuLink text={'Credentials'} href={`https://secretserver.calligo.cloud/SecretServer/dashboard.aspx?term=${hostName}`} />
            </Fragment>
          )}
        </MenuItem>

        <MenuItem>
          IMM: {isNil(host.imm_ip) ? 'Not found' : (
            <Fragment>
              <MenuLink text={host.imm_ip} href={`https://${host.imm_ip}`} />
              {' | '}
              <MenuLink text={'Credentials'} href={`https://secretserver.calligo.cloud/SecretServer/dashboard.aspx?term=${hostName}`} />
            </Fragment>
          )}
        </MenuItem>
        <MenuItem text={'IPAM'} href={`https://ipam.calligo.cloud/tools/search/${hostName}`} />
        <MenuItem text={'PRTG'} href={`https://${includes([4,5,6], host.location_id) ? 'prtgna' : 'prtg'}.calligo.cloud/searchdetailed.htm?searchtext=${hostName}`} />
      </MenuDropdown>
    </Menu>
  )
}

export default HostSubMenu
